import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
// import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';
import Grid from 'apollo-react/components/Grid';
import Paper from 'apollo-react/components/Paper';
import Typography from 'apollo-react/components/Typography';

const WorkflowVersions = ({ persona }) => {
    const { wfId } = useParams();
    const [t] = useTranslation();
    const [data, setData] = useState([]);
    const [versionsData, setVersionsData] = useState([]);
    // const [confirmActivateModal, setConfirmActivateModal] = useState({ open: false, record: null });

    const navigate = useNavigate();

    const [paginationParams, setPaginationParams] = useState({
      limit: 10,
      offset: 0,
      sortField: 'createdAt',
      sortOrder: -1,
      filters: {}
    });

    const onDataTableEvent = (event) => {
      setPaginationParams(prev => ({
        ...prev,
        limit: event.rows,
        offset: event.first,
        sortField: event.sortField || prev.sortField,
        sortOrder: event.sortOrder || prev.sortOrder
      }));
    };

    const fetchWorkflowVersions = async () => {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/workflows/${wfId}/versions`, { withCredentials: true })
      .catch((err) => {
          console.log(err);
      });

      console.log("Workflow versions Response:", response?.data);

      setData(response?.data);
      setVersionsData(response?.data?.WorkflowVersions);
  };

  useEffect(() => {
    fetchWorkflowVersions();
  }, []);

  const columns = [
    { field: "version", header: "Version", sortable: true, body: (rowData) => 'V' + rowData.version },
    { field: "name", header: "Name", sortable: true},
    { field: "createdAt", header: t("Creation Date"), sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
    { field: "publishedAt", header: t("Published At"), sortable: true, filter: true, body: (rowData) => new Date(rowData.publishedAt).toLocaleString('en-GB') },
  ];

  const actions = [
    { text: t("view"), color: "primary", onClick: (row) => navigate(`/${persona}/workflows/${row.wf_id}/versions/${row.id}/view`)},
    { text: t("edit"), color: "secondary", onClick: (row) => navigate(`/${persona}/workflows/${row.wf_id}/versions/${row.id}`)},
    // { text: 'Activate / Deactivate', color: "primary", onClick: (row) => setConfirmActivateModal({ open: true, record: row }) }
  ];

    return (
      <div>
        <DataTableComponent
          data={versionsData}
          columns={columns}
          actions={actions}
          onDataTableEvent={onDataTableEvent}
          paginationParams={paginationParams}
          totalRecords={versionsData?.length}
          enableCreate={false}
          enablePagination={true}
          enableLazyLoading={false}
          enableExport={true}
          // enableSelection= {true}
          // selection={selectedRows}
          // onSelectionChange={(e) => setSelectedRows(e.value)}
          // selectionMode="multiple"
        />
        
        {/* {confirmActivateModal.open && (
          <ActivateDeactivateModal
            sentData={confirmActivateModal.record}
              onEvent={setConfirmActivateModal}
              onConfirm={fetchWorkflowVersions}
              apiPath="versions"
              axios={axiosInstance}
              columnName="username"
              dbAction="active"
          />
        )} */}
            
      </div>
    );
};

export default WorkflowVersions;